import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconShareForwardBox.tsx
const IconShareForwardBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M9 2.999v2H4v14h16v-9h2v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1zm9.95 2L16 2.049 17.414.635l5.34 5.34a.6.6 0 0 1-.424 1.024H14a2 2 0 0 0-2 2v6h-2v-6a4 4 0 0 1 4-4z"
	})]
});
var IconShareForwardBox_default = forwardRef(IconShareForwardBox);
//#endregion
export { IconShareForwardBox_default as default };
